import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getStorageUrl } from '../../helpers/global';

function useStorageUrl(
  url: string | undefined | null,
  options?: Omit<UseQueryOptions<string | null>, 'queryKey' | 'queryFn'>,
) {
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: ['storageUrl', url],
    queryFn: async () => {
      if (!url) return null;
      const storageUrl = await getStorageUrl(url);
      if (!storageUrl) return null;
      return storageUrl;
    },
    ...options,
  });

  return { url: data || null, isLoading, isFetching, isError, error, refetch };
}

export default useStorageUrl;
